export default __webpack_public_path__ + "static/media/logo9.1c3c11d9.svg";